/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Send2Inputs */

const en_coinvestments_draftemail_send2 = /** @type {(inputs: Coinvestments_Draftemail_Send2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

/**
* | output |
* | --- |
* | "Send" |
*
* @param {Coinvestments_Draftemail_Send2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_send2 = /** @type {((inputs?: Coinvestments_Draftemail_Send2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Send2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_send2(inputs)
});
export { coinvestments_draftemail_send2 as "coInvestments_draftEmail_send" }